exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/node_modules/css-loader?{"sourceMap":false,"import":false}!/home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/styles-kavya.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles-kavya.css
// module chunks = styles